import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';
import { DISALLOWED_WORDS_REGEX, DISALLOWED_WORDS } from '../models/disallowed-words';

/** match against disallowed words, whole word must match */
export function disallowedWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        var isInvalidWord = (DISALLOWED_WORDS.indexOf(control.value.toLowerCase()) > -1) ? true : false;




        return isInvalidWord ? { 'disallowedWords': { value: control.value } } : null;
    };
}




@Directive({
    selector: '[disallowedWords]',
    //providers: [{ provide: NG_VALIDATORS, useExisting: DisallowedWordsValidatorDirective, multi: true }]
})
export class DisallowedWordsValidatorDirective {

    @Input()
    disallowedWords: AbstractControl;


    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {

        this.validate();
    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {

        this.validate();
    }

    validate() {


        if (!this.disallowedWords.errors) {

            this.disallowedWords.setErrors(disallowedWordsValidator()(this.disallowedWords));

        }
    }



}

